namespace advisorop.components.servicer {

    class RepFeeGroupWrapperServicerController {

        $router;
        selectedCompanyGroup: domains.ICompanyGroup;
        selectedCompanyGroupId: number;
        companyGroupSel: domains.ICompanyGroup;;
        static $inject = ["identityService", "servicerService"];
        constructor(public identityService: services.IdentityService, private servicerService: services.ServicerService) {
        }

        newCompanyGroupSelected(advisorFirm: domains.ICompanyGroup): void {
            this.selectedCompanyGroup = advisorFirm;
            this.companyGroupSel = this.selectedCompanyGroup;
        }

        giveMeCompanyGroupById(id: number): void {
            this.servicerService.getCompanyGroup(id).then(data => {
                this.companyGroupSel = data.data;
            }).catch(error => {
                toastr.error("Unable to get company group " + error.status + " " + error.data);
            });
        }
       

        $onInit(): void {
            
        }

        $routerOnActivate(next, previous) {
            if (next.params.id) { 
                this.selectedCompanyGroupId = next.params.id;
                this.giveMeCompanyGroupById(this.selectedCompanyGroupId)
            }
        }
    }


    class RepFeeGroupWrapperServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                $router: "<",
            };
            this.controller = RepFeeGroupWrapperServicerController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/rep-fee-group-wrapper-servicer.html';
        }
    }

    angular.module(Constants.APP).component("repFeeGroupWrapperServicer", new RepFeeGroupWrapperServicer());
}